<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { cn } from "@/shadcn-lib/utils";
import { type Ref, provide, ref } from "vue";

interface AccordionContext {
  type: "single" | "multiple";
  value: Ref<string[]>;
  onValueChange: (value: string[]) => void;
  collapsible?: boolean;
}

const props = defineProps<{
  type: "single" | "multiple";
  class?: HTMLAttributes["class"];
  collapsible?: boolean;
  defaultValue?: string | string[];
  modelValue?: string[];
  disabled?: boolean;
}>();

const emit = defineEmits<{
  "update:modelValue": [value: string[]];
}>();

const value = ref<string[]>(
  Array.isArray(props.defaultValue)
    ? props.defaultValue
    : props.defaultValue
    ? [props.defaultValue]
    : Array.isArray(props.modelValue)
    ? props.modelValue
    : []
);

const onValueChange = (newValue: string[]) => {
  value.value = newValue;
  emit("update:modelValue", newValue);
};

provide<AccordionContext>("accordion-context", {
  type: props.type,
  value,
  onValueChange,
  collapsible: props.collapsible,
});
</script>

<template>
  <div data-slot="accordion" :class="cn('flex flex-col gap-2', props.class)">
    <slot />
  </div>
</template>
